/* global axios */
import ApiClient from './ApiClient';

// Goals are a first-class resource (/goals), not a sub-resource of a report —
// a goal may or may not be attached to one.
class GoalsAPI extends ApiClient {
  constructor() {
    super('goals', { accountScoped: true });
  }

  evaluate(id) {
    return axios.post(`${this.url}/${id}/evaluate`);
  }

  evaluateAll() {
    return axios.post(`${this.url}/evaluate_all`);
  }
}

export default new GoalsAPI();
